import React, { Component } from "react";
// import firebase from "firebase/app";
// import Ripples from 'react-ripples';
// import firestore from "firebase/firestore";
// import { firebaseConfig } from "./FirebaseConfig";
// import { BrowserRouter as Router, Link } from "react-router-dom";
// import { Map, Circle, GoogleApiWrapper } from "google-maps-react";
// import Geocode from "react-geocode";
import AppBar from "./AppBar";
// import DashboardMap from "./DashboardMap";
import "./Maps.css";
import MapComponent from './MapComponent'

class Maps extends Component {

  constructor(props) {
    super(props)
    this.state = {
      admin_email:'admin@gmail.com'
    }
};

  render() {
    return (
      <div className={"mapsMainDiv"}>
        <div className={"mapsHeaderAppBarDiv"}>
          <AppBar message="MAP" email={this.state.admin_email}/>
        </div>

        <div className={"mapsFooterDiv"}>
          <div className={"mapsFooterListDiv"}>
              <MapComponent/>
          </div>
        </div>
    </div>
    );
  }
}
export default Maps
// export default GoogleApiWrapper({
//   apiKey: "AIzaSyA_d3pS7JqjFnGWc9hHkvT2MUQvAKo5Bio",
// })(Maps);
